import { motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';

export default function VehicleCard({ vehicleCards }) {
    const history = useHistory();

    const viewProducts = (value) => {
        history.push(`/product/${value._id}/view`);
    };

    return (
        <motion.div className="relative px-2 bg-white drop-shadow-lg py-10 w-full flex flex-col">
            <span className="text-xl font-bold my-5">Start your exciting ride!!!</span>
            <motion.div className="w-full overflow-x-auto whitespace-nowrap px-2 py-2">
                {vehicleCards &&
                    vehicleCards.map((vehicle, index) => (
                        <motion.div
                            key={index}
                            className="inline-block mr-2  cursor-pointer last:mr-0 min-w-[120px]"
                            onClick={() => viewProducts(vehicle)}
                        >
                            <img
                                src={vehicle.images[0]}
                                className="h-[300px] w-[500px] object-contain rounded-md"
                                alt="vehicle"
                            />
                        </motion.div>
                    ))}
            </motion.div>
        </motion.div>
    );
}
